import { updateBalance, updateCashbackExperience } from 'app/lib/account/reducers/clientInfo/clientInfoReducer';
import { setUnreadNotificationsCount } from 'app/lib/notifications/reducers/notifications.slice';
import { applyInterestingMatches, INTERESTING_MATCHES_TOPIC } from 'app/modules/LandingPage/InterestingMatches/actions';
import { applyLiveState, LIVE_TOPIC } from 'app/modules/Live/actions/liveHub';
import { applyFavoritesState, FAVORITES } from 'app/modules/PrematchFavorites/actions';
import { login, logout } from 'app/redux/actions/auth';

import {
  applyPrematchMatches,
  applyPrematchState,
  PREMATCH_MAIN_LINE_TOPIC,
  PREMATCH_MATCHES_TOPIC,
} from '../../../modules/PrematchWS/actions';
import { applyMatches, MATCHES_TOPIC_PREFIX } from '../redux/actions/subscribe-to-matches';

// ---

export const TRIGGERS_BY_TOPIC = {
  'update-balance': updateBalance,
  'update-cashback-experience': updateCashbackExperience,
  'set-unread-notifications-count': setUnreadNotificationsCount,
  'apply-state': {
    [MATCHES_TOPIC_PREFIX]: applyMatches,
    [INTERESTING_MATCHES_TOPIC]: applyInterestingMatches,
    [LIVE_TOPIC]: applyLiveState,
    [PREMATCH_MAIN_LINE_TOPIC]: applyPrematchState,
    [PREMATCH_MATCHES_TOPIC]: applyPrematchMatches,
    [FAVORITES]: applyFavoritesState,
  },
} as const;

export const SOCKET_RECONNECT_TRIGGERS = [
  login.fulfilled.toString(),
  logout.fulfilled.toString(),
] as const;
